export default __webpack_public_path__ + "static/media/utah.ff2434de.jpg";